import { z } from 'zod';

import type { TranslateFn } from '@/shared/types';

export function withAlpha(t: TranslateFn, schema: z.ZodString): z.ZodString {
    return schema.regex(/^[\p{L}\s]*$/u, t('validation.letters-only'));
}
